import request from '@/utils/server'
// 新增
export function addCombo(data) {
    return request({
      url: '/dish/addCombo',
      method: 'POST',
      data: data
    })
  }
 
    //   查询
export function getComboItem(query) {
    return request({
      url: '/dish/getComboItem',
      method: 'get',
      params: query
    })
  }